<template>
  <div style="min-width: 1100px; border: 1px solid rgba(0, 0, 0, 0.12);border-radius: 5px;" class="my-6 mx-6 pa-6">
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <v-simple-table v-else border>
      <template v-slot:default>
        <thead>
          <tr class='text-uppercase content-th'>
            <th class='text-left'
              style='background: #0d47a1; color: white; width: 23%; font-size: 14px; white-space: nowrap;'>
              đơn hàng nhập mới cần duyệt
            </th>
            <th style="width: 7%;white-space: nowrap;" class=" sty-th"> {{ countWorkList }} đơn </th>
            <th class='text-right sty-th'>
              số lượng
            </th>
            <th class='text-right sty-th'>
              tổng giá trị
            </th>
            <th class='text-left sty-th' colspan='2'>
              người tạo và ngày tạo
            </th>
          </tr>
        </thead>
        <tbody class="content-text">
          <tr v-if="!workList.length">
            <td colspan="6">
              Không có dữ liệu
            </td>
          </tr>
          <tr v-for='item in workList' :key='item.id'>
            <td style="width: 40%; font-size: 16px;color: #333333" colspan="2" class='font-weight-medium text-left'>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" class="text-ellipsis">
                      <span class="pr-6 text-blue">{{ item.code }}</span>
                      {{ item.productIndustry.name }} / {{ item.producer.name }} / {{ item.productType.name }}
                    </div>
                  </template>
                  <div>
                    {{ item.productIndustry.name }} / {{ item.producer.name }} / {{ item.productType.name }}
                  </div>
                </v-tooltip>
              </div>
            </td>
            <td style="width: 10%; font-size: 16px;color: #333333;" class="text-right">{{ item.expectedQuantity }}</td>
            <td style="width: 20%; font-size: 16px;" class='font-weight-medium text-green text-right'>
              {{ formatCurrency(+item.expectedWorth) }}
            </td>
            <td style="width: 30%; font-size: 16px;" class='font-weight-medium text-left'>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <div class="text-ellipsis">
                      <span class="text-blue">
                        {{ item.user.role | getRole }} {{ item.user.name }}</span> tạo lúc
                      {{ formatRelativeDate(item.createdAt) }}
                    </div>
                  </div>
                </template>
                <div>
                  {{ item.user.role | getRole }} {{ item.user.name }} tạo lúc {{ formatRelativeDate(item.createdAt) }}
                </div>
              </v-tooltip>
            </td>
            <td class="text-right">
              <router-link style='text-decoration: none' :to="'/import-order/' + item._id">
                <v-btn icon>
                  <v-icon color='primary' class='material-icon'>login</v-icon>
                </v-btn>
              </router-link>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false,
    }
  },
  async created() {
    this.loading = true
    await this.findLatestNeedApprove()
    await this.countLatestNeedApprove()
    this.loading = false
  },
  computed: {
    ...mapState({
      workList(state) {
        return state['importOrders'].workList
      },
      countWorkList(state) {
        return state['importOrders'].countWorkList
      },
    })
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString('vi-VN', { currency: 'VND' })
    },
    ...mapActions({
      findLatestNeedApprove: 'importOrders/findLatestNeedApprove',
      countLatestNeedApprove: 'importOrders/countLatestNeedApprove',
    }),
    formatRelativeDate(dateString) {
      const date = new Date(dateString)
      const now = new Date()

      const timeDiff = now - date
      const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60))

      if (hoursDiff < 24) {
        const options = { hour: 'numeric', minute: 'numeric' }
        return `${date.toLocaleTimeString('vi-VN', options)} ngày hôm nay`
      } else if (hoursDiff < 48) {
        const options = { hour: 'numeric', minute: 'numeric' }
        return `${date.toLocaleTimeString('vi-VN', options)} ngày hôm qua`
      } else {
        const time = { hour: 'numeric', minute: 'numeric' }
        const options = { day: 'numeric', month: 'numeric', year: 'numeric' }
        return `${date.toLocaleTimeString('vi-VN', time)} ngày ${date.toLocaleDateString('vi-VN', options)}`
      }
    },
  },
  watch: {}
}
</script>
<style scoped lang='scss'>
.text-blue {
  color: #0d47a1
}

.text-green {
  color: #46be8a
}

.header-cell {
  font-size: 14px;
}

.content-cell {
  font-size: 16px;
}

.sty-th {
  font-size: 14px;
  color: #999999;
}

.text-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
